(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFlickity() {
    if (typeof Flickity !== 'undefined') {
      var carousel = document.querySelector('.carousel');
      if (carousel && !carousel.classList.contains('flickity-enabled')) {
        new Flickity(carousel, {
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          wrapAround: true,
          autoPlay: 5000
        });
      }
    } else {
      setTimeout(initFlickity, 300);
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    var flickityScript = document.createElement('script');
    flickityScript.src = "https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js";
    flickityScript.onload = initFlickity;
    document.head.appendChild(flickityScript);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
